import { type IEmailValidatorResponse } from '@mahawi/eshop-rabbit';
import { createSlice } from '@reduxjs/toolkit';

import { requestFailedMatcher } from '../async-state';
import { type IEmailValidatorState } from './types';

export const preloadedState: IEmailValidatorState = {
  entries: {},
};

const emailValidatorSlice = createSlice({
  name: 'EmailValidator',
  initialState: preloadedState,
  reducers: {
    emailValidatorVerify: {
      reducer(
        state,
        action: { payload: { correlationId: string; email: string } },
      ) {
        state.entries[action.payload.correlationId] = {
          email: action.payload.email,
          inProcess: true,
        };
      },
      prepare(correlationId: string, email: string) {
        return { payload: { correlationId, email } };
      },
    },
    emailValidatorVerifyResponse: {
      reducer(
        state,
        action: {
          payload: { correlationId: string; result: IEmailValidatorResponse };
        },
      ) {
        const { correlationId, result } = action.payload;
        state.entries[correlationId] = {
          email: state.entries[correlationId]?.email ?? result.email,
          inProcess: false,
          result,
        };
      },
      prepare(correlationId: string, result: IEmailValidatorResponse) {
        return { payload: { correlationId, result } };
      },
    },
    emailValidatorReset: {
      reducer(state, action: { payload: { correlationId: string } }) {
        Reflect.deleteProperty(state.entries, action.payload.correlationId);
      },
      prepare(correlationId: string) {
        return { payload: { correlationId } };
      },
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(requestFailedMatcher('EmailValidator'), (state) => {
      Object.values(state.entries).forEach((entry) => {
        entry.inProcess = false;
      });
    });
  },
});

export const {
  emailValidatorVerify,
  emailValidatorVerifyResponse,
  emailValidatorReset,
} = emailValidatorSlice.actions;
export default emailValidatorSlice.reducer;
